import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import * as _ from 'lodash';
import * as $ from 'jquery';

import { AbstractItemModel } from '@/models/items/abstract-item-model';
import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';

import { UserModule } from '@/store/modules/user';

import moment from 'moment';

// @ts-ignore - seems to break without it?
@Component({})
export abstract class BaseListView extends Vue {
  get canEditList(): boolean {
    return ListModelUtil.canEditList(this.list, UserModule.currentUserId);
  }

  get loggedInUsername(): string {
    if (UserModule.userProfile) {
      return UserModule.userProfile.username;
    } else {
      return '';
    }
  }

  get updatedDate() {
    return moment(this.list.timeLastUpdated).format('MM/DD/YYYY');
  }
  @Prop(String) public listId?: string;
  @Prop(String) public slug?: string;
  @Prop(String) public username?: string;
  @Prop(ListModel) public loadedList?: ListModel;

  public error: boolean = false;

  public list: ListModel | null = null;
  public items: AbstractItemModel[] = [];
  public itemsDict: Map<string, AbstractItemModel> = new Map();
  public sortedItemTags: string[] = [];
  public filter: (item: AbstractItemModel) => boolean = null;
  public filterTag: string = null;

  public getImages(max: number) {
    return _.take(this.list.images, max);
  }

  public async findList(): Promise<firebase.firestore.DocumentReference> {
    if (this.listId) {
      return ListModelUtil.findListRefFromId(this.listId);
    } else if (this.slug && this.username) {
      return ListModelUtil.findListRefFromSlug({
        username: this.username,
        slug: this.slug
      });
    } else {
      throw new Error('missing things');
    }
  }

  public extractListTags() {
    const tagDict: Map<string, number> = new Map<string, number>();
    this.items.forEach((item) => {
      item.tags.forEach((tag) => {
        if (!(tag in tagDict)) {
          tagDict.set(tag, 0);
        }
        tagDict.set(tag, tagDict.get(tag) + 1);
      });
    });
    const sortedTags = _.sortBy(Array.from(tagDict.entries()), (tagItem) => {
      return tagItem[1];
    });
    this.sortedItemTags = _.map(sortedTags, (t) => t[0]);
  }

  public async loadList() {
    try {
      if (this.loadedList) {
        this.list = this.loadedList;
      } else {
        const doc = await this.findList();
        const list = await doc.get();
        this.list = ListModel.fromFirebaseDoc(doc.id, list.data());
      }
      this.onListLoaded();
    } catch (e) {
      this.error = true;
      console.error(e);
    }
  }

  public loadItems() {
    ListModelUtil.getItemsFromList(this.list).then((items) => {
      console.log('list updated - maybe items changed!!!');
      console.log(`were ${this.items.length} items`);
      items.forEach((item) => this.itemsDict.set(item.id, item));

      this.items = this.list.itemEntries.map((itemEntry) => {
        const item = this.itemsDict.get(itemEntry.itemId);
        if (!item) {
          console.error('could not deref itemId: ' + itemEntry.itemId);
        }
        return item;
      });
      this.items = this.items.filter((item) => !!item);
      console.log(`now ${this.items.length} items`);

      this.extractListTags();
      this.$forceUpdate();
      this.onItemsLoaded();
    });
  }

  public abstract onListLoaded(): void;
  public abstract onItemsLoaded(): void;

  public created() {
    this.loadList();
  }

  public currentItems(): AbstractItemModel[] {
    if (!this.filter) {
      return this.items;
    } else {
      return this.items.filter(this.filter);
    }
  }

  public onFilterChange(selectIndex: number) {
    if (selectIndex) {
      const tag = this.sortedItemTags[selectIndex];
      this.filter = (item: AbstractItemModel) => {
        return _.some(item.tags, (x) => x === tag);
      };
    } else {
      this.filter = null;
    }
  }
}
